import React, { useState } from 'react';
import { PhoneCall, Menu, X, MapPin, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navItems = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'New Patient',
    href: '/new-patients'
  }, {
    name: 'Financing',
    href: '/financing'
  }, {
    name: 'Services',
    href: '/#services'
  }, {
    name: 'Meet the Doctors',
    href: '/#meet-the-doctors'
  }, {
    name: 'Patient Reviews',
    href: '/#patient-reviews'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-81">
      {/* Top Banner */}
      <div className="bg-[#0F2C59] text-white py-2 px-4" data-id="element-82">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-[11px] font-bold uppercase tracking-widest gap-2" data-id="element-83">
          <div className="flex items-center gap-6 flex-wrap justify-center" data-id="element-84">
            {/* Language Toggle */}
            <div className="flex items-center bg-white/10 rounded-full px-2 py-1 gap-1" data-id="element-85">
              <button className="px-2 py-0.5 rounded-full bg-white text-[#0F2C59] transition-colors" data-id="element-86">
                EN
              </button>
              <button className="px-2 py-0.5 rounded-full text-white/70 hover:text-white transition-colors" data-id="element-87">
                ES
              </button>
            </div>
            <div className="hidden sm:block w-px h-3 bg-white/20" data-id="element-88" />
            <div className="flex items-center gap-2" data-id="element-89">
              <MapPin size={12} className="text-[#0D9488]" data-id="element-90" />
              <span data-id="element-91">Silver Spring, MD</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-92">
              <MapPin size={12} className="text-[#0D9488]" data-id="element-93" />
              <span data-id="element-94">Baltimore, MD</span>
            </div>
          </div>
          <div className="flex items-center gap-2 mt-2 sm:mt-0" data-id="element-95">
            <Phone size={12} className="text-[#0D9488]" data-id="element-96" />
            <span data-id="element-97">Front Desk: (301) 555-0123</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="bg-white/95 backdrop-blur-sm border-b border-slate-100" data-id="element-98">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
          <div className="flex justify-between items-center h-20" data-id="element-100">
            <div className="flex-shrink-0 flex items-center gap-3" data-id="element-101">
              <img src="https://cdn.magicpatterns.com/uploads/uTWzv2J5kt8GxQJy5fAuTB/pasted-image.png" alt="Colesville Dental Center Logo" className="h-10 w-auto" data-id="element-102" />
              <span className="text-xl font-bold tracking-tight text-[#0F2C59] hidden sm:block" data-id="element-103">
                COLESVILLE DENTAL CENTER
              </span>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex space-x-8 items-center" data-id="element-104">
              {navItems.map(item => <a key={item.name} href={item.href} className={`text-sm font-medium transition-colors flex items-center gap-1.5 ${item.name === 'New Patient' ? 'text-[#0D9488] hover:text-[#0F766E] bg-teal-50 px-3 py-1.5 rounded-full border border-teal-100' : 'text-[#4F709C] hover:text-[#0F2C59]'}`} data-id="element-105">
                  {item.name}
                  {item.name === 'New Patient' && <span className="flex h-2 w-2 rounded-full bg-[#0D9488] animate-pulse" data-id="element-106" />}
                </a>)}
            </nav>

            <div className="flex items-center gap-4" data-id="element-107">
              <button className="hidden sm:flex bg-[#0D9488] hover:bg-[#0F766E] text-white px-6 py-3 rounded-lg text-sm font-bold items-center gap-2 transition-all shadow-lg shadow-teal-900/10" data-id="element-108">
                <PhoneCall size={18} data-id="element-109" />
                Book an Appointment
              </button>

              {/* Mobile Menu Toggle */}
              <button className="lg:hidden p-2 text-[#0F2C59]" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-110">
                {isMenuOpen ? <X size={28} data-id="element-111" /> : <Menu size={28} data-id="element-112" />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-113">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="lg:hidden bg-white border-b border-slate-100 shadow-xl" data-id="element-114">
            <nav className="flex flex-col p-4 space-y-4" data-id="element-115">
              {navItems.map(item => <a key={item.name} href={item.href} onClick={() => setIsMenuOpen(false)} className={`text-lg font-bold py-2 border-b border-slate-50 flex items-center justify-between ${item.name === 'New Patient' ? 'text-[#0D9488]' : 'text-[#0F2C59]'}`} data-id="element-116">
                  {item.name}
                  {item.name === 'New Patient' && <span className="text-[10px] bg-[#0D9488] text-white px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-117">
                      Start Here
                    </span>}
                </a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}